/* unplugin-vue-components disabled */import script from "./EditorMask.vue?vue&type=script&setup=true&lang=js"
export * from "./EditorMask.vue?vue&type=script&setup=true&lang=js"

import "./EditorMask.vue?vue&type=style&index=0&id=9f1c6c76&lang=scss"

const __exports__ = script;

export default __exports__